import cn from "classnames"
import {AnchorLink} from "gatsby-plugin-anchor-links"
import {trackCustomEvent} from "gatsby-plugin-google-analytics"
import React, {useEffect, useState} from "react"
import LogoPic from "~/common/assets/logo-light.inline.svg"
import {ButtonContact} from "~/common/components/atoms/button-contact/button-contact"
import {URL_FEATURES, URL_SERVICES, URL_WHYDOXPRO} from "~/common/config/routes"
import "./navbar.scss"

type NavBarProps = {
  className?: string
}

export function Navbar({className}: NavBarProps) {
  const [burgerActive, setBurgerActive] = useState<boolean | null>(null)

  const headerLinksClass = cn("header__links", {active: burgerActive})
  const headerBurgerClass = cn("header__burger icon-burger", {
    active: burgerActive,
  })

  function handleBurgerToggle() {
    setBurgerActive(!burgerActive)
  }

  function onNavigationClick(linkName: string) {
    setBurgerActive(false)
    trackCustomEvent({
      category: "link",
      action: "click",
      label: linkName,
    })
  }

  useEffect(() => {
    if (burgerActive !== null) {
      burgerActive ? document.body.classList.add("lock") : document.body.classList.remove("lock")
      return () => {
        document.body.classList.remove("lock")
      }
    }
  }, [burgerActive])

  return (
    <header className={cn("header", className)}>
      <div className={"container container_fluid"}>
        <div className="header__body">
          <AnchorLink to="/" className="header__logo-pic">
            <LogoPic style={{width: 130}} />
          </AnchorLink>
          <nav className="header__menu">
            <div className={headerBurgerClass} onClick={handleBurgerToggle}>
              <span></span>
            </div>
            <ul className={headerLinksClass}>
              <li>
                <span onClick={() => onNavigationClick("why-doxpro")}>
                  <AnchorLink to={URL_WHYDOXPRO} className="header__link">
                    Why Doxpro?
                  </AnchorLink>
                </span>
              </li>
              <li>
                <span onClick={() => onNavigationClick("features")}>
                  <AnchorLink to={URL_FEATURES} className="header__link">
                    Features
                  </AnchorLink>
                </span>
              </li>
              <li>
                <span onClick={() => onNavigationClick("services")}>
                  <AnchorLink to={URL_SERVICES} className="header__link">
                    Services &amp; Pricing
                  </AnchorLink>
                </span>
              </li>
              {/* <li>
								<span onClick={() => onNavigationClick("blog")}>
									<AnchorLink to={URL_BLOG} className="header__link">
										Blog
									</AnchorLink>
								</span>
							</li> */}
              {burgerActive && (
                <li>
                  <ButtonContact>Contact Us</ButtonContact>
                </li>
              )}
            </ul>
          </nav>
          <div className="header__contacts">
            <ButtonContact>Contact Us</ButtonContact>
          </div>
        </div>
      </div>
    </header>
  )
}
